import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import proposalsApi from "../../../APIs/proposals";
import techniciansJobApi from "../../../APIs/technicians";
import {
  BrowsedAdditionalRequirement,
  BrowsedClientInformation,
  BrowsedCostAndShipping,
  BrowsedJobInformation,
  BrowsedPropertyInformation,
  BrowsedRequirementInformation,
} from "../../../components/TechnicianBrowsedJobDetails";
import BluePrints from "../../../components/TechnicianBrowsedJobDetails/Blueprints";
import {
  Button,
  Divider,
  Flex,
  NavigateBack,
  Tag,
  Typography,
} from "../../../designComponents";
import { CREATE_JOB_PROPOSAL_ROUTE } from "../../../routes/routePaths";
import { RootState } from "../../../store/selectors";
import { humanReadableDate, requestAPI } from "../../../utils";
import { ActionsContainer, ViewJobContainerStyled } from "./style";

const BrowseJobsDetails = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const onCreateProposal = () => {
    navigate(CREATE_JOB_PROPOSAL_ROUTE);
  };
  const proposal = useSelector((state: RootState) => state.ProposalsJob);

  const jobDetails = useSelector(
    (state: RootState) => state.technicianJobsDetails,
  );

  const getJobDetails = async (id: any) => {
    try {
      await requestAPI(techniciansJobApi.getTechnicianJobsDetail(id));
    } catch (error) {
      console.error(error);
    }
  };

  const getProposalsByJob = async (id: string) => {
    try {
      await requestAPI(proposalsApi.getProposalByJobId(id));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (jobId) {
      getProposalsByJob(jobId);
    }
  }, []);

  useEffect(() => {
    getJobDetails(jobId);
  }, [jobId]);

  const isProposalSend =
    jobId && proposal ? proposal?.find((p) => p.job?._id === jobId) : false;

  const additionalInfo =
    Array.isArray(jobDetails.additionalRequirement) &&
    jobDetails.additionalRequirement.length > 0
      ? jobDetails.additionalRequirement
      : [];

  const formatLogosData = () => {
    const imgs = jobDetails?.logo?.map((img, idx) => ({
      id: `${idx + 1}`,
      URL: img,
    }));

    return imgs;
  };
  return (
    <ViewJobContainerStyled>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "sticky",
          top: "60px",
          zIndex: "999",
          paddingTop: "5px",
          background: "#fff",
        }}
      >
        <NavigateBack />

        {!isProposalSend ? (
          <Button
            variant="secondary"
            size="sm"
            onClick={onCreateProposal}
            width="122px"
          >
            Create Proposal
          </Button>
        ) : (
          <Flex alignSelf="flex-end" justifyContent="flex-end">
            <Tag type="warning">Proposal Sent</Tag>
          </Flex>
        )}

        {/* )} */}
      </div>
      <div className="contents">
        <div className="heading">
          <Typography variant="title">Evacuation Plan for Hotels </Typography>
          <Tag type="success" style={{ padding: "3px 12px" }}>
            {jobDetails?.status}
          </Tag>
        </div>
        <Divider spaceY="20px" />
        <BrowsedJobInformation
          jobCreatedAt={humanReadableDate(jobDetails?.createdAt || "")}
          jobTitle={jobDetails?.jobTitle || ""}
          notes={jobDetails?.notes || ""}
        />
        <Divider spaceY="20px" />
        <BrowsedPropertyInformation
          addressOfProperty={jobDetails?.building?.buildingAddress || ""}
          buildingName={jobDetails?.building?.buildingName || ""}
          buildingId={jobDetails?.building?._id || ""}
        />
        <Divider spaceY="20px" />
        <BluePrints
          addressOfProperty={jobDetails?.building?.buildingAddress || ""}
          buildingName={jobDetails?.building?.buildingName || ""}
          buildingId="id_1"
          bluePrints={jobDetails?.building?.bluePrints || []}
        />

        <Divider spaceY="20px" />
        <BrowsedClientInformation
          name={jobDetails?.createdBy?.fullName || ""}
          avatar=""
          email={jobDetails?.createdBy?.emailAddress || ""}
        />
        <Divider spaceY="20px" />
        <BrowsedRequirementInformation
          frameColor={jobDetails?.frameColor || ""}
          materialTypeOfDrawing={jobDetails?.drawingMaterialType || ""}
          resolutionOfLogo={jobDetails?.logoResolution || ""}
          roundedEdge={jobDetails?.roundedEdge ? "Yes" : "No"}
          sizeOfDrawing={jobDetails?.drawingSize || ""}
          uploadedLogos={formatLogosData() || []}
        />
        <Divider spaceY="20px" />
        <BrowsedCostAndShipping
          pricing={`${jobDetails?.pricing || ""}`}
          shippingAddress={jobDetails?.shippingAddress || ""}
        />
        <Divider spaceY="20px" />
        {jobDetails.additionalRequirement?.length ? (
          <>
            <BrowsedAdditionalRequirement additionalInfo={additionalInfo} />
            <Divider spaceY="20px" />
          </>
        ) : (
          ""
        )}
        {/* <Typography
          variant="normal"
          strong
          fontColor="secondary"
          className="section-title"
        >
          ACTIONS
        </Typography> */}
        <ActionsContainer></ActionsContainer>
      </div>
    </ViewJobContainerStyled>
  );
};

export default BrowseJobsDetails;
